export default {
  1: {
    "type": "i4proTextField",
    "attributesTextField": {
      "label": "",
      "color": "primary",
      "clearable": true
    }
  },
  2: {
    "type": "i4proTextarea",
    "attributesTextField": {
      "label": "",
      "clearable": true,
      "rows": 5
    }
  },
  3: {
    "type": "i4proTextField",
    "rules": ["validateNumberInt"],
    "attributesTextField": {
      "label": "",
      "color": "primary",
      "clearable": true
    }
  },
  4: {
    "type": "i4proTextFieldDecimal",
    "attributesTextField": {
      "label": "",
      "color": "primary",
      "clearable": true
    },
    "formatDecimal": {
      "currencySymbol": "R$",
      "decimalCharacter": ",",
      "digitGroupSeparator": ".",
      "watchExternalChanges": true,
      "unformatOnHover": false
    }
  },
  5: {
    "type": "i4proCheckbox",
    "attributes": {
      "label": "",
      "attributesLabel":{
        "class":"ml-2 text-gray"
      }
    }
  },
  6: {
    "type": "i4proDatePickerMenu",
    "btnFlat": true,
    "btnShow": false,
    "btnCancelColor": "primary",
    "btnCancelLabel": "Cancelar",
    "btnTodayColor": "primary",
    "btnTodayLabel": "Hoje",
    "pickerAsButton": true,
    "pickerAsButtonIcon": "calendar_today",
    "pickerColor": "primary",
    "attributesMenu": {
      "transition": "scale-transition",
      "min-width": "290px",
      "offset-y": true
    },
    "attributesTextField": {
      "clearable": true,
      "label": "",
      "mask": "M#/y###"
    },
    "attributesDatePicker": {
      "locale": "pt-br",
      "type": "month"
    }
  },
  7: {
    "type": "i4proTimePickerMenu",
    "attributesMenu": {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": true,
      "maxWidth": "290px",
      "minWidth": "290px"
    },
    "attributesTextField": {
      "label": "",
      "clearable": true
    },
    "attributesTimePicker": {
      "format": "24hr"
    }
  },
  8: {
    "type": "i4proPassword",
    "attributesTextField": {
      "label": "",
      "color": "primary",
      "clearable": true
    }
  },
  9: {
    "type": "i4proColorPicker",
    "attributesTextField": {
      "label": "Clique aqui para definir uma cor",
      "clearable": true,
      "placeholder": "Selecione a cor desejada: ",
      "single-line": true
    },
    "attibutesColorPicker": {
      "show-swatches": true,
      "mode": "hexa"
    }
  },
  10: {
    "type": "i4proFileInput",
    "attributesTextField": {
      "label": "",
      "clearable": true,
      "prepend-inner-icon": "mdi-camera",
      "accept": "png,jpg,jpeg",
      "class": "mb-4"
    },
    "attributesChips": {
      "visible": true
    },
    "attributesFile": {
      "card": {
        "width": 200,
        "dark": true,
        "color": "primary",
        "class": "mb-4"
      },
      "image": {
        "height": "300px"
      }
    }
  },
  11: {
    "type": "i4proAutocomplete",
    "attributesSelect": {
      "label": "",
      "clearable": true,
      "items": [],
      "color": "primary",
      "prepend-inner-icon": "mdi-filter-outline",
      "autocomplete": "on"
    }
  },
  12: {
    "type": "i4proAutocomplete",
    "attributesTextField": {
      "label": "",
      "color": "primary",
      "clearable": true,
      "validateOnBlur": true,
      "appendIcon": "search"
    },
    "attributesDialog": {
      "cardTolbarTitle": "Selecione um item",
      "buttonColor": "info",
      "buttonLabel": "Clique aqui",
      "cardTolbarColor": "primary",
      "width": 800,
      "transition": "dialog-bottom-transition",
      "actionSpacer": true
    },
    "attributesTable": {
      "editIcon": "edit",
      "key": "código",
      "dataTable": {
        "singleSelect": true,
        "itemsPerPage": 10,
        "showSelect": true,
        "sortBy": [],
        "sortDesc": [],
        "dense": true,
        "singleExpand": true
      },
      "headers": [
        {
          "text": "Codigo",
          "value": "código"
        },
        {
          "text": "Descrição",
          "value": "descrição"
        }
      ]
    },
    "attributesSelect": {
      "label": "",
      "placeholder": "Digite no mínimo 3 caracteres...",
      "clearable": true,
      "prepend-icon": "mdi-database-search",
      "color": "primary",
      "dense": true,
      "value": 4.56,
      "menu-props": {
        closeOnClick: false,
        closeOnContentClick: false,
        disableKeys: true,
        openOnClick: false,
        maxHeight: 304,
        maxWidth: 800,
        offsetY: true,
        offsetOverflow: true,
        transition: false
      },
      "cacheItems": false
    },
    "searchParams": {
      "numberCharactersSearch": 3,
      "text": "descrição",
      "value": "código"
    },
    "editIcon": "edit",
    "key": "código"
  }
}